<img
  [src]="src"
  [alt]="alt"
  [attr.srcset]="srcset"
  [attr.id]="elementId"
  [attr.class]="classNames"
  [attr.width]="width"
  [attr.height]="height"
/>
